export default __webpack_public_path__ + "static/media/Bg1.08655f24.jpg";